export const queryKeys = {
  plpProducts: (handle: string, searchParamsString?: string) =>
    [`plp-${handle}-products`, searchParamsString || ''] as const,
  plpRelatedProducts: (handle: string, titles: string[] = []) =>
    [`plp-${handle}-related-products`, titles] as const,
  plpInitialFilters: (handle: string) =>
    [`plp-${handle}-initial-filters`] as const,
}
